import { Text } from '@wix/design-system';
import React from 'react';
import s from './SaleTimer.scss';
import { useCurrentModule } from '../ModuleProvider';
const TimeUnit = _ref => {
  let {
    value,
    unit,
    minWidth
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, minWidth ? /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth,
      display: 'inline-block',
      textAlign: 'center'
    }
  }, value) : value, ' ', unit);
};
export const SaleTimer = _ref2 => {
  let {
    hours,
    minutes,
    seconds,
    mobile = false
  } = _ref2;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Text, {
    weight: mobile ? 'thin' : 'normal',
    size: "small",
    skin: "standard",
    light: false,
    className: s.saleBannerText
  }, /*#__PURE__*/React.createElement(TimeUnit, {
    value: hours,
    unit: t('eclipse.sale.countdown.hours')
  }), ' : ', /*#__PURE__*/React.createElement(TimeUnit, {
    value: minutes,
    unit: t('eclipse.sale.countdown.minutes')
  }), ' : ', /*#__PURE__*/React.createElement(TimeUnit, {
    value: seconds,
    unit: t('eclipse.sale.countdown.seconds'),
    minWidth: "18px"
  }));
};
//# sourceMappingURL=SaleTimer.js.map